export enum gridSortDirections {
    asc = 'asc',
    desc = 'desc',
}
